import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout';
import FileManager from './FileManager/FileManager';

const Media = () => {
    const menuDispatch = useDispatch();

    useEffect(() => {
        menuDispatch({
            type: 'menuSelect',
            payload: 'media-all'
        });
    }, [menuDispatch]);

    return (
        <>
            <PageHeaderLayout headerTitle={'File Manager'}> </PageHeaderLayout>
            <FileManager/>
        </>
    );
};

export default Media;
